import Vue from 'vue';
import Quill from 'quill';
import katex from 'katex';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'katex/dist/katex.min.css';
import 'quill-paste-smart';
import ImageResize from 'quill-image-resize';
import { ImageDrop } from 'quill-image-drop-module';
import { registerNestedListClipboard } from './quill-nested-lists';

const ATTRIBUTES = ['alt', 'height', 'width', 'style'];

const ParchmentEmbed = Quill.import('blots/block/embed');

class ImageWithStyle extends ParchmentEmbed {
  static create(value) {
    let node = super.create(value);

    if (typeof value === 'string') {
      node.setAttribute('src', this.sanitize(value));
    }
    return node;
  }

  static formats(domNode) {
    return ATTRIBUTES.reduce(function (formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  static match(url) {
    return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
  }

  static sanitize(url) {
    return url;
    //return sanitize(url, ['http', 'https', 'data']) ? url : '//:0';
  }

  static value(domNode) {
    return domNode.getAttribute('src');
  }

  format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

window.katex = katex;

ImageWithStyle.blotName = 'imagewithstyle';
ImageWithStyle.tagName = 'IMG';

// class ShiftEnterBlot extends ParchmentEmbed {} // Actually EmbedBlot
// ShiftEnterBlot.blotName = "shiftenter";
// ShiftEnterBlot.tagName = "br";

// Quill.register(ShiftEnterBlot, true);
// Quill.register(ImageWithStyle, true); //ปิดไว้เพราะทำให้รูปที่แทรกอยู่ในข้อความโดนดึงออกมาจาก element และโดนย้ายไปไว้ด้านล่าง
// Must run after quill-paste-smart's own clipboard registration (its import above),
// so the nested-list handling wraps that module rather than being replaced by it.
registerNestedListClipboard();

Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/imageDrop', ImageDrop);

Vue.use(VueQuillEditor);

function contentWatchOverride(newVal) {
  if (this.quill) {
    if (newVal && newVal !== this._content) {
      this._content = newVal;
      const delta = this.quill.clipboard.convert(newVal);
      this.quill.setContents(delta);
    } else if (!newVal) {
      this.quill.setText('');
    }
  }
}

const Base = Vue.options.components['quill-editor'];

const CustomQuillEditor = Base.extend({
  beforeCreate() {
    Vue.set(this.$options.watch, 'content', contentWatchOverride.bind(this));
    Vue.set(this.$options.watch, 'value', contentWatchOverride.bind(this));
  }
});

export default CustomQuillEditor;
